"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegendTooltip = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLegendTooltip = styled_components_1.default.img `
  left: ${(props) => (props.left ? props.left : 'unset')};
  height: 12px;
  margin: 0;
  position: relative;
  right: ${(props) => (props.right ? props.right : 'unset')};
`;
